import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spreadsheet = _resolveComponent("Spreadsheet")!
  const _component_window = _resolveComponent("window")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_window, {
      ref: "windowRef",
      width: '1200px',
      visible: _ctx.visible,
      title: _ctx.title,
      "position-top": 100,
      "position-left": 32,
      actions: _ctx.actions
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Spreadsheet, {
          jsondata: _ctx.jsondata,
          bus: _ctx.bus,
          importType: _ctx.importType,
          ref: "form"
        }, null, 8, ["jsondata", "bus", "importType"]),
        _createElementVNode("button", {
          class: "btn btn-sm btn-primary mt-2",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
          style: {"background-color":"#0054a6","color":"white"}
        }, _toDisplayString(_ctx.$t("dialogBox.upload")), 1)
      ]),
      _: 1
    }, 8, ["visible", "title", "actions"])
  ]))
}